import { render, staticRenderFns } from "./ConfigurationAlert.vue?vue&type=template&id=1a0e2e48"
import script from "./ConfigurationAlert.vue?vue&type=script&lang=js"
export * from "./ConfigurationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports